import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../hooks/useAuth'
import styles from './LoginPage.module.css'

export function LoginPage() {
  const { t } = useTranslation()
  const { login } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [submitting, setSubmitting] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)
    setSubmitting(true)

    const err = await login(email, password)
    if (err) setError(err)

    setSubmitting(false)
  }

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.logo}>MIREY</div>
        <p className={styles.tagline}>{t('common.tagline')}</p>

        {error && <div className={styles.error}>{error}</div>}

        <form className={styles.form} onSubmit={handleSubmit}>
          <label className={styles.label}>
            {t('auth.email')}
            <input
              type="email"
              className={styles.input}
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              autoComplete="email"
              disabled={submitting}
            />
          </label>

          <label className={styles.label}>
            {t('auth.password')}
            <input
              type="password"
              className={styles.input}
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              disabled={submitting}
            />
          </label>

          <button type="submit" className={styles.button} disabled={submitting}>
            {submitting ? t('common.loading') : t('auth.login')}
          </button>
        </form>

        <p className={styles.switchLink}>
          {t('auth.no_account')}{' '}
          <Link to="/register">{t('auth.create_account')}</Link>
        </p>
      </div>
    </div>
  )
}
